import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import ErrorStoreProvider from 'components/video-player-fresh/error-layer/ErrorStoreProvider';
import { ConnectedRouter } from 'connected-react-router';
import type { History } from 'history';
import React from 'react';
import { Provider } from 'react-redux';
import { createRootReducer } from 'reducers';
import type { Store } from 'redux';
import { GraphQLProvider } from '../utilities/graphql';

interface Props {
  store: Store | null;
  history: History;
}

export const LoomProviders: React.FC<Props> = ({
  store,
  history,
  children,
}) => {
  return (
    <Provider
      store={
        store ||
        configureStore({
          reducer: createRootReducer(history),
          middleware: getDefaultMiddleware(),
        })
      }
    >
      <ConnectedRouter history={history}>
        <GraphQLProvider>
          <ErrorStoreProvider>{children}</ErrorStoreProvider>
        </GraphQLProvider>
      </ConnectedRouter>
    </Provider>
  );
};
